const messages = {
  title: "Everything you need",
  text: "to boost your project",
  paragraph: "Design, UI/UX, Websites, Apps and more!",
  btnSwip: "¡Swip!",
  btnContent: "To get a boost"
};

export default messages;
